import React, { useState, useEffect } from "react";
import { Table, Button, Form, Modal } from "react-bootstrap";
import { FaEye, FaDownload, FaRegFilePdf, FaTrash } from "react-icons/fa";
import axios from "axios";
import { toast } from 'react-toastify';


const PdfList = () => {
  const [pdfFiles, setPdfFiles] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [newDoc, setNewDoc] = useState({ name: "", fileName: "" });

  const loadDocuments = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/documents`, {
        params: { page, limit: 10, search }
      });
      setPdfFiles(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Erro ao carregar documentos:", error);
    }
  };

  useEffect(() => {
    loadDocuments();
  }, [page, search]);


  // const handleDownload = (fileName) => {
  //   const link = document.createElement("a");
  //   link.href = `${process.env.REACT_APP_API_IMG}/assets/pdfs/${fileName}`;
  //   link.setAttribute("download", fileName); // força o download
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_API_IMG}/assets/pdfs/${fileName}`;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleAdd = async () => {
    try {
      const formData = new FormData();
      formData.append('name', newDoc.name);
      formData.append('file', newDoc.file);

      await axios.post(`${process.env.REACT_APP_API_URL}/documents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Documento cadastrado com sucesso!', {
        position: 'top-right',
        autoClose: 2000
      });

      setShowModal(false); // Fecha o modal apenas após sucesso
      setNewDoc({ name: '', file: null }); // Limpa o formulário
      loadDocuments(); // Recarrega a lista

    } catch (error) {
      toast.error('Erro ao cadastrar documento.', {
        position: 'top-right',
        autoClose: 3000
      });
    }
  };


  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null);

  const iconStyle = { color: '#D00000', fontSize: '24px', marginRight: '8px' };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Contratos</h2>
      <Button variant="success" onClick={() => setShowModal(true)}>
        Novo Documento
      </Button>
      
      <Form.Control
        type="text"
        placeholder="Buscar por nome do contrato..."
        className="mb-3 mt-3"
        value={search}
        onChange={(e) => {
          setPage(1); // volta pra primeira página ao buscar
          setSearch(e.target.value);
        }}
      />

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Nome</th>
            <th style={{ width: "15%"}}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((pdf) => (
            <tr key={pdf._id}>
              <td><FaRegFilePdf style={iconStyle} /> {pdf.name}</td>
              <td>
                <Button variant="outline-success" href={`${process.env.REACT_APP_API_IMG}/assets/pdfs/${pdf.fileName}`} target="_blank">
                  <FaEye />
                </Button>{' '}
                <Button variant="outline-primary" onClick={() => handleDownload(pdf.fileName)}>
                  <FaDownload />
                </Button>{' '}
                <Button variant="outline-danger" onClick={() => {
                  setSelectedDocId(pdf._id);
                  setShowConfirmModal(true);
                }}>
                  <FaTrash />
                </Button>

              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <span>Página {page} de {totalPages}</span>
        <div>
          <Button
            variant="secondary"
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
            className="me-2"
          >
            Anterior
          </Button>
          <Button
            variant="secondary"
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            Próxima
          </Button>
        </div>
      </div>


      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir este documento? Esta ação não poderá ser desfeita.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={async () => {
            await axios.delete(`${process.env.REACT_APP_API_URL}/documents/${selectedDocId}`);
            toast.success('Documento excluído com sucesso!', {
              position: 'top-right',
              autoClose: 2000
            });
            setShowConfirmModal(false);
            loadDocuments();
          }}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal de Novo Documento */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton><Modal.Title>Novo Documento</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Nome do Documento</Form.Label>
            <Form.Control
              type="text"
              value={newDoc.name}
              onChange={(e) => setNewDoc({ ...newDoc, name: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Arquivo PDF</Form.Label>
            <Form.Control
              type="file"
              accept="application/pdf"
              onChange={(e) => setNewDoc({ ...newDoc, file: e.target.files[0] })}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleAdd}>Salvar</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default PdfList;
